import getBG from '../../utils/utils';

export default {
    name: 'demand-feedback',
    data() {
        return {
            demand: {
                systemType: []
            },
            rules: {
                contactsMan: [{ required: true, message: '联系人' }],
                systemType: [{ required: true, message: '系统类型' }],
                hotelName: [{ required: true, message: '酒店名称' }],
                mobile: [{ required: true, message: '联系人电话' }]
            },
            systems: [],
            backgroundImage: '',
            loading: false
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.getSystemType();
            this.backgroundImage = await getBG.call(this, 'DemandFeedback');
        },
        // 查询系统类型
        getSystemType() {
            this.$http
                .fetchData('codes/getCodesList', {
                    category: 'SystemType'
                })
                .then(res => {
                    console.log(res);
                    this.systems = res;
                    console.log(this.systems);
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        },
        // 提交意见反馈
        addDemandFeedback() {
            // 增加输入校验
            // if (!this.demand || !this.demand.contactsMan || this.demand.contactsMan.length < 2) {
            //     this.$message({
            //         message: '请填写正确的联系人',
            //         type: 'error'
            //     });
            //     return;
            // }

            // if (
            //     !this.demand ||
            //     !this.demand.hotelName ||
            //     this.demand.hotelName.length < 4 ||
            //     this.demand.hotelName.length > 20
            // ) {
            //     this.$message({
            //         message: '请填下正确的公司名称',
            //         type: 'error'
            //     });
            //     return;
            // }

            // if (!this.demand || !this.demand.mobile || this.demand.mobile.length < 11) {
            //     console.log('2222');
            //     this.$message({
            //         message: '请填写正确的手机号码',
            //         type: 'error'
            //     });
            //     return;
            // }

            // const chinaPhoneNumberRegex = /^1[3-9]\d{9}$/;
            // // 示例：校验中国大陆的手机号码
            // if (!chinaPhoneNumberRegex.test(this.demand.mobile)) {
            //     console.log('1111', this.demand.mobile);
            //     this.$message({
            //         message: '请填写正确的手机号码',
            //         type: 'error'
            //     });
            //     return;
            // }

            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    const arr = [];
                    if (this.demand.systemType.length > 0) {
                        this.demand.systemType.forEach(item => {
                            this.systems.forEach(system => {
                                if (item === system.name) {
                                    item = system.code;
                                    arr.push(system.code);
                                }
                            });
                        });
                        this.demand.systemType = arr.join(',');
                    } else {
                        this.demand.systemType = arr.join(',');
                    }
                    this.$http
                        .fetchData('demandFeedback/addDemandFeedback', {
                            ...this.demand,
                            systemType: this.demand.systemType
                        })
                        .then(res => {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.loading = false;
                            this.demand = {
                                systemType: []
                            };
                        })
                        .catch(err => {
                            console.log(err);
                            this.$message({
                                message: err,
                                type: 'error'
                            });
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 重置
        reset() {
            this.demand = {
                systemType: []
            };
        }
    }
};
